// Español
import type { Messages } from "./pt-BR";

const es: Messages = {
  "common.loading": "Cargando…",
  "common.close": "Cerrar",
  "common.back": "Volver",
  "common.theme": "Cambiar tema",
  "common.language": "Idioma",
  "common.error": "Algo salió mal. Inténtalo de nuevo.",

  "auth.login": "Entrar",
  "auth.loginField": "Usuario o correo",
  "auth.password": "Contraseña",
  "auth.forgotLink": "Olvidé mi contraseña",
  "auth.newHere": "¿Eres nuevo?",
  "auth.createAccount": "Crear cuenta",
  "auth.haveAccount": "¿Ya tienes cuenta?",
  "auth.username": "Usuario",
  "auth.usernameHint": "De 3 a 20 caracteres: minúsculas, números y _. Se usa para entrar.",
  "auth.email": "Correo",
  "auth.emailHint": "Te enviaremos un enlace de confirmación. Sirve para recuperar la contraseña.",
  "auth.nickname": "Apodo",
  "auth.nicknameHint": "Cómo apareces en las partidas (de 3 a 16 caracteres).",
  "auth.passwordHint": "Al menos 8 caracteres.",
  "auth.confirm": "Confirmar contraseña",
  "auth.err.login": "Escribe tu usuario o correo.",
  "auth.err.password": "Escribe tu contraseña.",
  "auth.err.username": "De 3 a 20 caracteres: minúsculas, números y _.",
  "auth.err.email": "Correo no válido.",
  "auth.err.nickname": "El apodo necesita de 3 a 16 caracteres.",
  "auth.err.passwordShort": "Usa al menos 8 caracteres.",
  "auth.err.confirm": "Las contraseñas no coinciden.",
  "auth.forgot": "Recuperar contraseña",
  "auth.forgotText": "Escribe tu correo. Si existe una cuenta, enviaremos un enlace válido por 30 minutos.",
  "auth.sendLink": "Enviar enlace",
  "auth.backToLogin": "Volver a entrar",
  "auth.forgotSent": "Si el correo está registrado, el enlace llegará en breve. Revisa también el spam.",
  "auth.newPassword": "Nueva contraseña",
  "auth.newPasswordTitle": "Crear nueva contraseña",
  "auth.savePassword": "Guardar contraseña",
  "auth.passwordChanged": "¡Contraseña cambiada! Entra con la nueva contraseña.",
  "auth.linkIncomplete": "Enlace incompleto. Pide uno nuevo en Recuperar contraseña.",
  "auth.verifyTitle": "Confirmar correo",
  "auth.verifying": "Confirmando…",
  "auth.goMenu": "Ir al menú",
  "auth.verified": "¡Correo confirmado!",
  "auth.verifyFailed": "Enlace no válido o caducado. Pide un nuevo enlace de confirmación desde el menú.",

  "err.offline": "Sin conexión con el servidor. Revisa tu internet.",
  "err.invalidCredentials": "Usuario, correo o contraseña incorrectos.",
  "err.tooManyAttempts": "Demasiados intentos. Espera unos minutos y vuelve a intentarlo.",
  "err.rateLimited": "Demasiadas solicitudes seguidas. Espera un poco.",
  "err.usernameTaken": "Ese usuario ya está en uso.",
  "err.emailTaken": "Ya existe una cuenta con ese correo.",
  "err.invalidToken": "Enlace no válido o caducado. Pide uno nuevo.",
  "err.banned": "Esta cuenta está suspendida.",
  "err.nicknameCooldown": "Solo puedes cambiar el apodo cada {days} días.",
  "err.alreadyVerified": "Tu correo ya está confirmado.",
  "err.unauthenticated": "Tu sesión caducó. Vuelve a entrar.",
  "err.validation": "Revisa los campos marcados.",
  "err.invalidDeck": "Mazo no válido: 1 carta de cada nivel y como máximo 1 por categoría (2 Energías).",
  "err.notOwned": "Todavía no tienes ese objeto.",
  "err.alreadyOwned": "Ya tienes ese objeto.",
  "err.paymentProvider": "Mercado Pago no respondió. Inténtalo de nuevo en un momento.",

  "title.set": "Set 1 · Kanto",
  "title.start": "Empezar",
  "title.tap": "Toca para empezar",
  "title.credits": "Créditos",

  "menu.title": "Menú",
  "menu.accountLevel": "Nivel de cuenta {n}",
  "menu.logout": "Salir",
  "menu.welcome": "¡Cuenta creada! Bienvenido, {name}.",
  "menu.confirmEmail": "Confirma tu correo ({email}) para poder recuperar la contraseña si la olvidas.",
  "menu.resend": "Reenviar enlace",
  "menu.play": "Jugar",
  "menu.play.sub": "Partida normal · hasta 8 jugadores",
  "menu.ranked": "Clasificatoria",
  "menu.ranked.sub": "Temporada 1 · Kanto",
  "menu.ranked.locked": "Confirma el correo para desbloquear",
  "menu.deck": "Mazo de cartas",
  "menu.deck.sub": "Oro · Plata · Cobre",
  "menu.ranking": "Clasificación",
  "menu.ranking.sub": "Mejores de la temporada e historial",
  "menu.collection": "Colección",
  "menu.collection.sub": "Variocolores",
  "menu.shop": "Tienda VIP",
  "menu.shop.sub": "Cristales y tableros",
  "menu.friends": "Jugar con amigos",
  "menu.friends.text": "Acordad un código y todos entráis en la misma sala. Quien entre primero decide cuándo empezar.",
  "menu.friends.placeholder": "Código de sala (ej.: PALLET)",
  "menu.friends.join": "Entrar",
  "menu.linkSent": "¡Enlace enviado! Revisa tu bandeja de entrada (y el spam).",
  "menu.err.verify": "Confirma tu correo para jugar clasificatorias.",
  "menu.err.connect": "No se pudo conectar con el servidor de juego.",
  "menu.err.code": "Usa un código con al menos 3 letras o números.",
  "menu.rejoin": "Tienes una partida en curso.",
  "menu.rejoin.button": "Volver a la partida",
  "menu.rejoin.expired": "La partida ya terminó o el tiempo para volver caducó.",

  "lobby.title": "Buscando partida",
  "lobby.players": "Jugadores",
  "lobby.playersCount": "Jugadores ({n}/{max})",
  "lobby.start": "Empezar ahora",
  "lobby.leave": "Salir de la cola",
  "lobby.you": "tú",
  "lobby.cancelled": "Partida cancelada: pocos jugadores. Vuelve al menú e inténtalo de nuevo.",
  "lobby.hint.solo": "Puedes empezar solo: las rondas de PvP serán contra entrenadores del juego. O espera a que entre más gente.",
  "lobby.hint.host": "Eres el dueño de la sala: empieza cuando quieras.",
  "lobby.hint.wait": "Esperando a que el dueño de la sala empiece (o a que se llene).",

  "match.level": "Nv. {n}",
  "match.badges": "Medallas",
  "match.quit": "Salir de la partida",
  "match.trainers": "Entrenadores",
  "match.traits": "Sinergias",
  "match.traits.empty": "Coloca unidades en el tablero para activar sinergias.",
  "match.lockShop": "Bloquear tienda",
  "match.free": "gratis ({n})",
  "match.round.pve": "Salvajes",
  "match.round.pvp": "Batalla",
  "match.round.safari": "Zona Safari",
  "match.round.gym": "Líder de Gimnasio",
  "match.err.not-enough-gold": "Oro insuficiente",
  "match.err.bench-full": "Banquillo lleno",
  "match.err.board-full": "Tablero lleno para tu nivel. Sube de nivel con XP",
  "match.err.max-level": "Nivel máximo",
  "match.err.items-full": "La unidad ya tiene 3 objetos",
  "match.err.not-planning": "Espera a la fase de planificación",
  "match.err.rate-limited": "¡Calma! Demasiadas acciones por segundo",
  "match.range": "alcance {n}",
  "match.mana": "maná",
  "match.sell": "Vender +{n}",
  "match.equip": "Equipar",
  "match.equipHint": "Ahora toca la unidad que recibirá el componente",
  "match.badge.choose": "Elige la bonificación de la medalla.",
  "match.branch.choose": "Elige la evolución",
  "match.backpack": "Mochila: elige un componente",
  "match.safari.text": "Elige un Pokémon (con componente). Quien tenga menos vida elige primero.",
  "match.safari.picked": "Elección guardada. Puedes cambiarla hasta que acabe el tiempo.",
  "match.safari.toast": "Zona Safari: ¡elige un Pokémon!",
  "match.gym.toast": "¡{leader} quiere combatir! Gana para elegir la bonificación de la {badge}.",
  "match.quit.title": "¿Salir de la partida?",
  "match.quit.text": "Tu tablero sigue en la partida, parado, hasta que termine. Puedes volver desde el menú.",
  "match.quit.yes": "Salir",
  "match.quit.no": "Seguir jugando",
  "match.end.league": "¡Ganaste la Liga de Kanto!",
  "match.end.journey": "Fin del viaje",
  "match.end.top4": "¡Top 4!",
  "match.end.over": "Fin de la partida",
  "match.end.points": "{n} puntos",
  "match.end.xp": "+{n} XP de cuenta",
  "match.end.levelUp": "¡Subiste al nivel {n}!",
  "match.end.newCard": "Nueva carta:",
  "match.end.shiny": "¡Nuevo variocolor desbloqueado! Míralo en la Colección.",
  "match.end.menu": "Volver al menú",
  "match.reconnecting": "Conexión perdida. Reconectando…",
  "match.reconnectFailed": "No se pudo volver a la partida.",
  "match.vs.wild": "Salvajes / Líder",
  "match.vs.npc": "Entrenador del juego",
  "match.combat": "Combate",
  "match.combatVs": "Combate · vs {name}",

  "tip.component": "Componente",
  "tip.item": "Objeto",
  "tip.combine": "Junta 2 componentes en la misma unidad para formar un objeto:",
  "tip.onBoard": "{n} en el tablero",
  "stat.adPct": "+{v}% de daño de ataque",
  "stat.ap": "+{v} de poder de habilidad",
  "stat.asPct": "+{v}% de velocidad de ataque",
  "stat.critPct": "+{v}% de probabilidad de crítico",
  "stat.armor": "+{v} de armadura",
  "stat.mr": "+{v} de resistencia mágica",
  "stat.hp": "+{v} de vida",
  "stat.startMana": "+{v} de maná inicial",

  "tier.gold": "Oro",
  "tier.silver": "Plata",
  "tier.copper": "Cobre",
  "deck.title": "Mazo de cartas",
  "deck.yours": "Tu mazo · Kanto",
  "deck.empty": "Vacío",
  "deck.emptyHint": "Elige una carta de este nivel en la colección de abajo.",
  "deck.save": "Guardar mazo",
  "deck.rules": "1 carta de cada nivel · hasta {energy} Energías y 1 de cada otra categoría",
  "deck.allUnlocked": " · todas desbloqueadas (nivel {n}+)",
  "deck.unlockAt": " · todas se desbloquean en el nivel {n}",
  "deck.collection": "Colección",
  "deck.all": "Todas",
  "deck.locked": "Consíguela subiendo de nivel",
  "deck.saved": "¡Mazo guardado! Se aplica desde la próxima partida.",
  "deck.needAll": "Elige una carta para cada nivel (Oro, Plata y Cobre).",

  "ranking.title": "Clasificación",
  "ranking.noSeason": "No hay ninguna temporada activa ahora.",
  "ranking.endsIn": "termina en {n} día(s)",
  "ranking.you": "Tú:",
  "ranking.unranked": "Sin partidas clasificatorias",
  "ranking.placement": "{n} partida(s) de posicionamiento (puntos dobles)",
  "ranking.trainer": "Entrenador",
  "ranking.games": "Partidas",
  "ranking.elo": "Rango",
  "ranking.gamesWins": "{n} ({w} victorias)",
  "ranking.empty": "Nadie ha jugado clasificatorias todavía. ¡Sé el primero!",
  "ranking.history": "Tus últimas partidas",
  "ranking.placeOf": "{p}.º de {n}",
  "ranking.mode.ranked": "Clasificatoria",
  "ranking.mode.custom": "Con amigos",
  "ranking.mode.normal": "Normal",
  "ranking.noMatches": "Todavía no hay partidas.",
  "ranking.pts": "{n} pts",
  "rank.pokeball": "Poké Ball",
  "rank.greatball": "Super Ball",
  "rank.ultraball": "Ultra Ball",
  "rank.masterball": "Master Ball",

  "collection.title": "Colección",
  "collection.text": "Los variocolores son solo visuales: todos los ven en la partida. Cómpralos con Pokédólares o consíguelos subiendo de nivel de cuenta (cada 5 niveles) y con tu mejor rango de la temporada.",
  "collection.showOwned": "Mostrar solo los tuyos",
  "collection.showingOwned": "Mostrando solo los tuyos",
  "collection.count": "{n} de {total}",
  "collection.tapToEquip": "Toca para equipar",
  "rarity.common": "Común",
  "rarity.rare": "Raro",
  "rarity.epic": "Épico",
  "rarity.legendary": "Legendario",

  "shop.title": "Tienda VIP",
  "shop.crystals": "cristales",
  "shop.tab.boards": "Tableros",
  "shop.tab.crystals": "Cristales",
  "shop.tab.history": "Historial",
  "shop.boards.explain": "Los tableros cambian la arena de la partida. En un combate entre dos jugadores, ambos ven el tablero de quien tenga más vida; la próxima vez que se enfrenten, el del otro. Solo visual: no da ventaja.",
  "shop.default": "Predeterminado",
  "shop.default.desc": "El clásico estadio azul y rojo, gratis para todos.",
  "shop.equip": "Equipar",
  "shop.equipped": "Equipado",
  "shop.animated": "Animado",
  "shop.preview": "Vista previa",
  "shop.confirmBuy": "¿Confirmar? {price}",
  "shop.bought": "¡{name} comprado y equipado!",
  "shop.notEnough": "Cristales insuficientes. Mira los paquetes de cristales.",
  "shop.crystals.explain": "Los cristales son donaciones que ayudan a mantener el servidor. Solo compran objetos visuales y nunca dan ventaja en el juego.",
  "shop.bonus": "de bonificación",
  "shop.donate": "Donar {price}",
  "shop.mp.note": "Pago procesado por Mercado Pago (Pix, tarjeta o boleto). Los cristales se añaden en cuanto se aprueba el pago.",
  "shop.devMode": "Modo de prueba: no se cobra nada (servidor sin Mercado Pago configurado).",
  "shop.paymentsOff": "Donaciones no disponibles en este momento.",
  "shop.donation.ok": "¡Gracias por tu donación! Se añadieron {n} cristales.",
  "shop.donation.waiting": "Esperando la confirmación del pago…",
  "shop.donation.failed": "El pago no se completó. No se cobró nada.",
  "shop.history.empty": "Todavía no hay donaciones.",
  "shop.history.date": "Fecha",
  "shop.history.value": "Importe",
  "shop.history.status": "Estado",
  "shop.status.pending": "Pendiente",
  "shop.status.in_process": "En revisión",
  "shop.status.approved": "Aprobado",
  "shop.status.rejected": "Rechazado",
  "shop.status.cancelled": "Cancelado",
  "shop.status.refunded": "Reembolsado",
  "shop.status.charged_back": "Contracargo",
  "shop.devCheckout.title": "Pago de prueba",
  "shop.devCheckout.text": "Simula el resultado del pago de esta donación.",
  "shop.devCheckout.approve": "Aprobar pago",
  "shop.devCheckout.reject": "Rechazar",

  "credits.title": "Créditos",
  "credits.sprites": "Sprites de Pokémon",
  "credits.spritesText": "Animaciones de {source}, licencia {license}. Arte de:",
  "credits.items": "Objetos, datos y fuentes",
  "credits.itemsText": "Iconos de objetos, nombres y datos de las especies: {source} / PokéAPI.",
  "credits.fonts": "Fuentes: Jersey 10 y DotGothic16 (SIL Open Font License).",
  "credits.trademark": "Pokémon y todos los nombres relacionados son marcas de Nintendo, Game Freak y Creatures. Proyecto de fans, sin afiliación.",
  "credits.error": "No se pudieron cargar los créditos.",

  // efeitos de combate
  "fx.effective": "eficaz",
  "fx.shield": "escudo",
  "fx.stun": "aturdido",
  "fx.sleep": "zzz",
  "fx.freeze": "congelado",
  "fx.confuse": "confuso",
  "fx.burn": "quemado",
  "fx.poison": "envenenado",
  "fx.intangible": "intangible",
  // foto de perfil
  "avatar.change": "Cambiar foto de perfil",
  "avatar.title": "Elige tu foto de perfil",
  "avatar.search": "Buscar Pokémon",
  "avatar.saved": "¡Foto de perfil actualizada!",
  "market.title": "Tienda Pokémon",
  "market.tab.special": "Especiales",
  "market.tab.item": "Objetos completos",
  "market.tab.component": "Componentes",
  "market.explain": "Los objetos comprados entran en tu reserva de objetos: en las recompensas de la partida, los objetos completos de tu reserva pueden caer ya montados (6% por objeto, hasta 30%) y los componentes caen con el doble de probabilidad.",
  "market.inPool": "{n} en tu reserva.",
  "market.owned": "En tu reserva",
  "market.bought": "¡{name} entró en tu reserva de objetos!",
  "match.end.pokedollars": "+{n} Pokédólares",
  "menu.market": "Tienda",
  "menu.market.sub": "Objetos con Pokédólares",
  "pdx.confirm": "¿Comprar? {price}",
  "pdx.explain": "Pokédólares: gana de 0 a 100 por partida (1.er puesto = 100). Compra cartas, variocolores y objetos.",
  "pdx.notEnough": "Pokédólares insuficientes. Juega partidas para ganar más.",
  "tip.special": "Especial",
  "tip.specialHint": "Solo en la Tienda: cae ya montado en la partida y ocupa 2 espacios.",
  "changelog.title": "Novedades",
  "changelog.version": "Versión {v}",
  "changelog.new": "Nuevo",
  "changelog.link": "Novedades de la versión {v}",
  "tip.unit.cost": "Coste {n}",
  "tip.unit.evolves": "Evolución:",
  "tip.unit.branch": "a elegir",
  "tip.unit.owned": "Ya tienes {n} copia(s): 3 copias forman un ★2.",
  "social.title": "Amigos y chat",
  "social.global": "Global",
  "social.friendsTab": "Amigos",
  "social.say": "Escribe un mensaje…",
  "social.send": "Enviar",
  "social.empty": "Todavía no hay mensajes.",
  "social.addPlaceholder": "Usuario de tu amigo",
  "social.add": "Añadir",
  "social.incoming": "Solicitudes de amistad",
  "social.outgoing": "Solicitudes enviadas",
  "social.friends": "Amigos ({n})",
  "social.noFriends": "Añade amigos por su nombre de usuario.",
  "social.remove": "Eliminar",
  "social.requestSent": "¡Solicitud enviada!",
  "social.nowFriends": "¡Ahora sois amigos!",
  "social.roomChat": "Chat de la sala",
  "social.err.notFound": "Usuario no encontrado.",
  "social.err.self": "No puedes añadirte a ti mismo.",
  "social.err.already": "Ya sois amigos.",
  "social.err.notFriends": "Solo puedes chatear con amigos.",
  "menu.creche": "Guardería",
  "menu.creche.sub": "Cría y desbloquea Pokémon",
  "creche.title": "Guardería",
  "creche.explain": "Cría un Pokémon de una línea bloqueada hasta el nivel {max} para desbloquear esa línea en tu tienda de la partida. Cuídalo y juega partidas: gana XP contigo.",
  "creche.level": "Nivel {n}/{max}",
  "creche.unlocks": "desbloquea la línea de {name}",
  "creche.xp": "XP",
  "creche.belly": "Barriga",
  "creche.happiness": "Felicidad",
  "creche.mood.hungry": "¡Tiene hambre! Aliméntalo para que gane XP completa.",
  "creche.mood.sad": "Está triste… juega con él.",
  "creche.mood.joy": "¡Muy feliz! Gana XP completa en las partidas.",
  "creche.mood.ok": "Está bien. Gana XP completa en las partidas.",
  "creche.feed": "Alimentar",
  "creche.play": "Jugar",
  "creche.train": "Entrenar",
  "creche.tips": "Cada partida da 20 XP (10 si tiene hambre o está triste). Jugar: cada 30 min. Entrenar: cada 2 h, da 30 XP.",
  "creche.release": "Liberar este Pokémon",
  "creche.releaseConfirm": "Toca otra vez para liberar (se pierde el progreso)",
  "creche.choose": "Elige un Pokémon para criar. Al llegar al nivel máximo, su línea empieza a aparecer en tu tienda de la partida.",
  "creche.allDone": "¡Desbloqueaste todas las líneas! Tu Pokédex está completa.",
  "creche.dex": "Pokédex de Kanto: {n}/{total} desbloqueados",
  "creche.adopted": "¡{name} llegó a la Guardería!",
  "creche.unlocked": "¡{name} ya está en tu tienda!",
  "creche.gotXp": "+{n} XP",
  "creche.err.not-hungry": "Ahora no tiene hambre.",
  "creche.err.too-hungry": "Tiene demasiada hambre. Aliméntalo primero.",
  "creche.err.too-sad": "Está demasiado triste para entrenar. Juega con él.",
  "creche.err.cooldown": "Necesita descansar un poco.",
  "menu.missions": "Misiones",
  "menu.missions.sub": "Premios diarios en ₽",
  "missions.title": "Misiones diarias",
  "missions.intro": "Completa las misiones jugando partidas y reclama el premio. Nuevas misiones en",
  "missions.resetsIn": "{t}",
  "missions.streak": "{n} día(s) seguido(s) jugando",
  "missions.best": "Récord: {n}",
  "missions.completedTotal": "{n} misiones completadas",
  "missions.seeRanking": "Ver ranking",
  "missions.claimed": "Reclamado",
  "missions.got": "¡+₽ {n}!",
  "missions.hint": "El progreso cuenta al final de cada partida.",
  "missions.doneInMatch": "¡{n} misión(es) completada(s)! Reclama el premio.",
  "missions.k.synergy": "Consigue {n} de {trait} en una partida",
  "missions.k.play": "Juega {n} partidas",
  "missions.k.win": "Gana {n} partida(s)",
  "missions.k.tophalf": "Termina en la mitad superior {n} veces",
  "missions.k.ranked-play": "Juega {n} clasificatoria(s)",
  "missions.k.ranked-win": "Gana {n} clasificatoria(s)",
  "missions.k.pvp-wins": "Gana {n} rondas contra jugadores",
  "missions.k.star3": "Consigue un Pokémon de 3 estrellas",
  "missions.k.items": "Ten {n} objetos completos en el tablero",
  "missions.k.level": "Llega al nivel {n} en una partida",
  "ranking.tab.ranked": "Clasificatoria",
  "ranking.tab.level": "Nivel",
  "ranking.tab.missions": "Misiones",
  "ranking.tab.streak": "Días seguidos",
  "ranking.about.level": "Nivel de la cuenta: sube con la XP de cada partida.",
  "ranking.about.missions": "Total de misiones diarias completadas y reclamadas.",
  "ranking.about.streak": "Días seguidos entrando al juego. Si faltas un día, la racha se reinicia.",
  "ranking.col.level": "Nivel",
  "ranking.col.missions": "Misiones",
  "ranking.col.streak": "Días",
  "ranking.levelValue": "Nv. {n}",
  "ranking.missionsValue": "{n}",
  "ranking.streakValue": "{n} días",
  "ranking.bestStreak": "récord {n}",
  "match.migrating": "Actualizando el servidor… volviendo a la partida.",
  "queue.searching": "Buscando partida…",
  "queue.searchingRanked": "Buscando clasificatoria…",
  "queue.starting": "Entrando en la cola",
  "queue.progress": "{time} · {n} en cola · rango ±{range}",
  "queue.cancel": "Cancelar",
  "match.vs.ghost": "{name} (tablero grabado)",
  "common.sound": "Sonido y vibración",
  "menu.achievements": "Logros",
  "menu.achievements.sub": "Títulos y marcos",
  "ach.title": "Logros",
  "ach.unlocked": "desbloqueados",
  "ach.titleLabel": "Título",
  "ach.frameLabel": "Marco",
  "ach.none": "Ninguno",
  "ach.secretName": "Logro secreto",
  "ach.secretDesc": "Sigue jugando para descubrirlo.",
  "ach.frameReward": "marco",
  "ach.saved": "Perfil actualizado.",
  "ach.cat.jornada": "Viaje",
  "ach.cat.colecao": "Colección",
  "ach.cat.habilidade": "Habilidad",
  "ach.cat.secreta": "Secretos",
  "ach.frame.ouro": "Oro",
  "ach.frame.prata": "Plata",
  "ach.frame.master": "Master Ball",
  "ach.frame.pokedex": "Pokédex",
  "ach.frame.shiny": "Brillante",
  "ach.toast": "¡Logro: {name}!",
  "ach.inMatch": "¡{n} logro(s) nuevo(s)!",
  "report.button": "Denunciar o bloquear",
  "report.title": "Denunciar a {name}",
  "report.why": "¿Qué pasó?",
  "report.reason.nickname": "Apodo ofensivo",
  "report.reason.chat": "Chat ofensivo o spam",
  "report.reason.afk": "Abandonó / inactivo",
  "report.reason.cheating": "Trampas",
  "report.reason.other": "Otro",
  "report.details": "Detalles (opcional)",
  "report.alsoBlock": "También bloquear a esta persona",
  "report.note": "Guardamos los mensajes recientes como prueba. Las denuncias falsas pueden ser sancionadas.",
  "report.send": "Denunciar",
  "report.blockOnly": "Solo bloquear",
  "report.unblock": "Desbloquear",
  "report.thanks": "¡Gracias! La moderación lo revisará.",
  "social.muted": "Tu chat está silenciado hasta {when}.",
  "mod.title": "Moderación",
  "mod.open": "Abiertas",
  "mod.closed": "Resueltas",
  "mod.by": "por {name} · {when}",
  "mod.counts": "{open} denuncia(s) abiertas · {people} persona(s) distintas",
  "mod.mutedUntil": "silenciado hasta {when}",
  "mod.bannedUntil": "suspendido hasta {when}",
  "mod.nickAtTime": "Apodo en ese momento: {name}",
  "mod.evidence": "Pruebas ({n} mensajes)",
  "mod.room": "sala",
  "mod.noEvidence": "Sin mensajes guardados.",
  "mod.dismiss": "Archivar",
  "mod.mute24": "Silenciar 24 h",
  "mod.rename": "Renombrar",
  "mod.ban3d": "Suspender 3 días",
  "mod.ban1y": "Banear",
  "mod.confirm": "¿Confirmar?",
  "mod.result": "{action} · {when}",
  "mod.empty": "No hay denuncias aquí.",
  "mod.done": "Hecho.",
  "menu.moderation": "Moderación",
  "share.tagline": "Autochess de Pokémon en el navegador",
  "share.ofN": "de {n}",
  "share.solo": "solo",
  "share.trainer": "Entrenador",
  "share.team": "Mi equipo",
  "share.level": "Nivel {n}",
  "share.round": "Ronda {r}",
  "share.wins": "{n} victorias",
  "share.cta": "Juega gratis — sin descargar",
  "share.text": "¡Quedé {place}º de {n} en PokéChess! Juega gratis: {url}",
  "share.button": "Compartir resultado",
  "share.downloaded": "¡Imagen guardada!",
  "ach.primeira-partida.name": "Primeros pasos",
  "ach.primeira-partida.desc": "Juega tu primera partida.",
  "ach.partidas-10.name": "Entrenador novato",
  "ach.partidas-10.desc": "Juega {n} partidas.",
  "ach.partidas-100.name": "Veterano",
  "ach.partidas-100.desc": "Juega {n} partidas.",
  "ach.partidas-1000.name": "Leyenda de Kanto",
  "ach.partidas-1000.desc": "Juega {n} partidas.",
  "ach.primeira-vitoria.name": "Primera victoria",
  "ach.primeira-vitoria.desc": "Gana una partida contra otros jugadores.",
  "ach.vitorias-10.name": "Campeón",
  "ach.vitorias-10.desc": "Gana {n} partidas.",
  "ach.vitorias-50.name": "Imparable",
  "ach.vitorias-50.desc": "Gana {n} partidas.",
  "ach.top4-25.name": "Siempre en el podio",
  "ach.top4-25.desc": "Termina entre los 4 primeros {n} veces.",
  "ach.ranqueada-vitorias-10.name": "As de la Liga",
  "ach.ranqueada-vitorias-10.desc": "Gana {n} clasificatorias.",
  "ach.master-ball.name": "Maestro Pokémon",
  "ach.master-ball.desc": "Llega a Master Ball en una temporada.",
  "ach.dias-7.name": "Una semana firme",
  "ach.dias-7.desc": "Juega {n} días seguidos.",
  "ach.dias-30.name": "Fiel",
  "ach.dias-30.desc": "Juega {n} días seguidos.",
  "ach.missoes-50.name": "Cumplidor de misiones",
  "ach.missoes-50.desc": "Completa {n} misiones diarias.",
  "ach.nivel-20.name": "Entrenador experto",
  "ach.nivel-20.desc": "Llega al nivel de cuenta {n}.",
  "ach.criadouro-1.name": "Primero de la Guardería",
  "ach.criadouro-1.desc": "Desbloquea una línea en la Guardería.",
  "ach.pokedex-completa.name": "Profesor",
  "ach.pokedex-completa.desc": "Desbloquea las {n} líneas de la Guardería.",
  "ach.shinies-5.name": "Brillo raro",
  "ach.shinies-5.desc": "Ten {n} variocolores.",
  "ach.shinies-25.name": "Cazador de variocolores",
  "ach.shinies-25.desc": "Ten {n} variocolores.",
  "ach.cartas-10.name": "Coleccionista",
  "ach.cartas-10.desc": "Ten {n} cartas.",
  "ach.agua-7.name": "Maestro del Agua",
  "ach.agua-7.desc": "Consigue 7 de Agua en una partida.",
  "ach.voador-7.name": "Dueño de los cielos",
  "ach.voador-7.desc": "Consigue 7 de Volador en una partida.",
  "ach.brigao-6.name": "Pelea callejera",
  "ach.brigao-6.desc": "Consigue 6 Peleones en una partida.",
  "ach.muralha-6.name": "Inquebrantable",
  "ach.muralha-6.desc": "Consigue 6 Murallas en una partida.",
  "ach.tres-estrelas-3.name": "Estrellado",
  "ach.tres-estrelas-3.desc": "Ten 3 Pokémon ★3 a la vez.",
  "ach.vitoria-por-um-fio.name": "Por un pelo",
  "ach.vitoria-por-um-fio.desc": "Gana con 5 de vida o menos.",
  "ach.nivel-9.name": "Nivel máximo",
  "ach.nivel-9.desc": "Llega al nivel 9 en una partida.",
  "ach.itens-6.name": "Arsenal",
  "ach.itens-6.desc": "Ten 6 objetos completos en el tablero.",
  "ach.giovanni.name": "Venció a Giovanni",
  "ach.giovanni.desc": "Supera la partida en solitario hasta la 8-7.",
  "ach.dragonite-3.name": "Dragón legendario",
  "ach.dragonite-3.desc": "Consigue un Dragonite ★3.",
  "ach.magikarp-3.name": "¡Salpicadura!",
  "ach.magikarp-3.desc": "Consigue un Magikarp ★3.",
  "ach.so-custo-1.name": "Humilde",
  "ach.so-custo-1.desc": "Gana usando solo Pokémon de coste 1.",
  "ach.sem-vitoria-top4.name": "Superviviente",
  "ach.sem-vitoria-top4.desc": "Queda en el top 4 sin ganar ningún combate.",
  "ach.mewtwo.name": "Clon poderoso",
  "ach.mewtwo.desc": "Pon un Mewtwo en el campo.",
  "tut.coach": "Profesor Oak",
  "tut.next": "Siguiente paso",
  "tut.shop": "Esta es la tienda. Toca un Pokémon para comprarlo: el número es su precio en oro.",
  "tut.place": "Fue al banco. Arrástralo al tablero: solo luchan los que están en el tablero.",
  "tut.fight": "¿Listo? Toca ¡Luchar! La batalla es automática.",
  "tut.watch": "Tus Pokémon luchan solos. Ganando consigues oro y objetos.",
  "tut.combine": "3 Pokémon iguales se vuelven ★2, mucho más fuertes. Los que ya tienes brillan en la tienda.",
  "tut.traits": "Los Pokémon del mismo tipo activan sinergias. Mira en Sinergias cuáles están activas.",
  "tut.items": "¡Conseguiste un componente! Tócalo y luego toca un Pokémon para equiparlo. Dos componentes forman un objeto.",
  "tut.xp": "Compra XP para subir de nivel: cada nivel permite poner un Pokémon más en el tablero.",
  "tut.interest": "Consejo: guardar oro da intereses, +1 por cada 10 (hasta +5) por ronda.",
  "tut.end": "¡Ahora te toca! Gana esta lucha para terminar el tutorial.",
  "tut.fightBtn": "¡Luchar!",
  "tut.offerTitle": "¿Primera vez aquí?",
  "tut.offer": "Aprende a jugar en 3 minutos con una partida guiada y gana ₽ {n}.",
  "tut.start": "Empezar tutorial",
  "tut.skip": "Ya sé jugar",
  "tut.done": "¡Tutorial completado!",
  "menu.tutorial": "Tutorial",
  "menu.tutorial.sub": "Aprende en 3 minutos",
  "lobby.fillBots": "Completar con bots",
  "lobby.fillBotsHint": "Los lugares libres pasan a ser entrenadores del juego.",
};
export default es;
